import { render, staticRenderFns } from "./workout-highlight-item.vue?vue&type=template&id=4f25b4cc&"
import script from "./workout-highlight-item.vue?vue&type=script&lang=js&"
export * from "./workout-highlight-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports